export const themeColor = {
  light: "white",
  dark: "black",
  gray: "#EAEAEA",
};
